// HomeWeb.jsx
import React, { useEffect } from 'react';
import { Text, ScrollView, View, Image, TouchableOpacity, Platform, Linking } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from './components/baseWeb';
import styles from './styles/celerWebStyles';
import { useLogScreen } from '../useLogScreen';

export default function PlanejadorRedesWeb() {
    useLogScreen('PlanejamentoRedes');
    const navigation = useNavigation();
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Planejador de Redes Sociais';
            }, 100);
        }
    }, []);
    return (
        <BaseWeb>
            {(userInfo) => {
                const usuario_id = userInfo?.id;
                return (
                    <ScrollView contentContainerStyle={styles.contentMinimal}>
                        <Text style={styles.title}>Planejamento de Redes Sociais</Text>

                        <View style={styles.container}>

                            <View style={styles.row}>
                                <Text style={styles.checkboxLabel} allowFontScaling={false}>
                                    Selecione uma das opções abaixo
                                </Text>
                            </View>

                            <View style={styles.row}>
                                <View style={styles.optionButtonsContainer}>
                                    <TouchableOpacity style={styles.optionButton} onPress={() => {
                                        Linking.openURL('https://cdn.imogo.com.br/manuais/dando_os_primeiros_passos.pdf');
                                    }}>
                                        <Image
                                            source={require('../assets/icons/download.png')} // Ícone de "Carregar um arquivo"
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Dando os primeiros passos</Text>
                                            <Text style={styles.optionTextSubtitle} allowFontScaling={false}>Baixe o pdf</Text>
                                        </View>
                                    </TouchableOpacity>

                                    <TouchableOpacity style={styles.optionButton} onPress={() => {
                                        Linking.openURL('https://juk.re/cronograma-postagem');
                                    }}>
                                        <Image
                                            source={require('../assets/icons/download.png')} // Ícone de "Carregar um arquivo"
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Planilha de cronograma de postagens</Text>
                                            <Text style={styles.optionTextSubtitle} allowFontScaling={false}>Baixe a planilha de cronograma</Text>
                                        </View>
                                    </TouchableOpacity>

                                    <TouchableOpacity style={styles.optionButton} onPress={() => {
                                        Linking.openURL('https://www.canva.com/design/DAGdnOpmQEM/LIuZfAtKG-HtZ_u2ean2LA/view?utm_content=DAGdnOpmQEM&utm_campaign=designshare&utm_medium=link2&utm_source=uniquelinks&utlId=hdbb9cdba40');
                                    }}>
                                        <Image
                                            source={require('../assets/icons/download.png')} // Ícone de "Carregar um arquivo"
                                            style={styles.optionIcon}
                                        />
                                        <View style={styles.optionTextContainer}>
                                            <Text style={styles.optionTextTitle} allowFontScaling={false}>Modelo de card no canva</Text>
                                            <Text style={styles.optionTextSubtitle} allowFontScaling={false}>Acesse a pasta no canva</Text>
                                        </View>
                                    </TouchableOpacity>
                                </View>
                            </View>

                            <View style={styles.buttonContainer}>
                                <TouchableOpacity style={styles.laterButton} onPress={() => navigation.navigate('Home', { usuario_id })}>
                                    <Image
                                        source={require('../assets/icons/home.png')}
                                        style={styles.laterIcon}
                                    />
                                    <Text style={styles.laterButtonText} allowFontScaling={false}>Voltar pra home</Text>
                                </TouchableOpacity>
                            </View>
                        </View>
                    </ScrollView>
                );
            }}
        </BaseWeb>
    );
}